import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn } from '../shared/interface/generic-interface';

@Injectable({
  providedIn: 'root'
})
export class VisitasService {

  constructor(
    private apiConService: ApiConService
  ) { }

  async getVisitas(roteiros: String){
    let response: JsonReturn = await this.apiConService.patch(`DCroteiroPedido/pedido/visitas/${roteiros}`)
    return response;
  }

  async getListaDeAcoes(numeroRoteiro){
    try{
      let response: JsonReturn =  await this.apiConService.patch('DCcoordenadas/listaDeAcoes/' + numeroRoteiro );
      return response.response;
    }catch (Error) {
      console.log(Error);
      return [];
    }
  }

  async getRoteiro(numeroRoteiro){
    let response: JsonReturn = await this.apiConService.patch('DCroteiroPedido/' + numeroRoteiro + '/0');
    return response.response;
  }
}
